import { render } from "./TrainingCalendar.vue?vue&type=template&id=4c510180&scoped=true"
import script from "./TrainingCalendar.vue?vue&type=script&lang=js"
export * from "./TrainingCalendar.vue?vue&type=script&lang=js"

import "./TrainingCalendar.vue?vue&type=style&index=0&id=4c510180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c510180"]])

export default __exports__